/**
 * The user-guide PDFs live in the production Perch S3 bucket and are linked from every
 * environment, so they resolve through one fixed host rather than the current environment's.
 *
 * AB#59708: once the production CloudFront distribution exists, only USER_GUIDES_BASE_URL changes
 * — to `https://<prod cdn host>/guides` — and the direct S3 host is gone. It still points at S3
 * because that distribution has not been created yet (the request has been open with infra since
 * 2025-05-14); guessing its hostname would break every guide link in the app.
 */
export const USER_GUIDES_BASE_URL = 'https://s3.us-west-2.amazonaws.com/s3.abi.prod/guides';

export const PERCH_USER_GUIDE_URL = `${USER_GUIDES_BASE_URL}/Quick%20Perch%20User%20Guide%202024%20-%20PDF.pdf`;

export function customRequestUserGuideUrl(isWholesaler: boolean): string {
  const audience = isWholesaler ? 'Wholesalers' : 'Employees';

  return `${USER_GUIDES_BASE_URL}/Custom-Request-Training-Guide-${audience}-2025.pdf`;
}
